import styled, { css } from 'styled-components';
import color from 'tinycolor2';
import {
  MenuList,
  MenuListItem,
  SVGIcon,
  Input,
  Button,
  Tooltip,
} from '@pearsontechnology/aero-components';
import { status, publishFormat } from '../../utils/constants';
import { ModalContent, ModalActions } from 'components/Modal';

export const AugmentedModalContent = styled(ModalContent)`
  margin-right: 5px;
`;

export const ListWrapper = styled(MenuList)`
  padding: 20px 30px 0;
  height: 339px;
  overflow-x: hidden;
  overflow-y: auto;

  :after {
    content: '';
    display: block;
    padding-bottom: 140px;
  }
`;

export const DangerButton = styled(Button)`
  margin-left: auto;
  color: ${(props) => props.theme['color.orangeDark']};
`;

export const Note = styled(Input)`
  min-height: 100px;
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme['color.text.body']};
`;

export const InfoCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 92px;
  padding: 10px 50px 10px 16px;
  background-color: ${(props) => color(props.theme['color.background']).setAlpha(0.8).toString()};
  margin-bottom: 20px;
  border-radius: 4px;
  box-sizing: content-box;
`;
export const InfoCardList = styled.ul`
  padding-left: 16px;
`;

export const InfoCardLabel = styled.p`
  margin: 0;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const InputLableWrapper = styled.div`
  padding-left:27px ;
  margin-bottom: 15px;
`;

export const OutputInfoFormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const LandmarkEntry = styled.div`
  display: flex;
  color: ${(props) => props.theme['color.red.text']};
  align-items: center;
  justify-content: flex-start;
  line-height: 19.07px;
`;

export const AccessibilityNote = styled.span`
  color: ${(props) => props.theme['color.blueLight']};
`;

export const Checkmark = styled.div`
  &:after {
    content: "\\2713";
    color: grey;
  }
`;

export const Asterisk = styled.span`
  color: ${(props) => props.theme['color.red.text']};
`;

export const InfoIcon = styled.div`
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1px solid grey;
  display: flex;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
  &:after {
    content: "i";
    color: grey;
    font-weight: 600;
  }
`;

export const AccessibilityToolTip = styled.div`
  background-color: ${(props) => props.theme['color.surface']};
  border-radius: 20px;
  position: absolute;
  padding: 10px 16px;
  top: 220px;
  display: flex;
  justify-content: center;
  &:before {
    content: "";
    height: 20px;
    width: 20px;
    position: absolute;
    transform: rotate(45deg);
    top: -5px;
    border-radius: 2px;
    z-index: -1;
  }
`;

export const AccessibilityToolTipMessage = styled.p`
  width: 240px;
  color: ${(props) => props.theme['color.text.body']};;
`;

export const ListItem = styled(MenuListItem)`
  display: flex;
  height: auto;
  min-height: min-content;
  font-size: 14px;
  line-height: 18px;
  padding-top: 5px;
  padding-bottom: 5px;

  &:focus {
    box-shadow: none;
  }

  & svg {
    margin-right: 15px;
  }
`;

export const BackButton = styled.div`
  display: flex;
  padding-left: 25px;
  margin-bottom: -10px;
  margin-top: -6px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${(props) =>
    props.disabled ?
      color(props.theme['color.text.body']).setAlpha(0.3).toString() :
      props.theme['color.text.body']};
  pointer-events: ${(props) => props.disabled ? 'none' : 'auto'};

  &:hover {
  cursor:pointer;
  }
`;

export const BackText = styled.h2`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;
  margin-top: -3px;
  margin-bottom: 1px;
  display: flex;
  align-items: center;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    font-size: 18px;
}`;

export const IconBack = styled(SVGIcon)`
  margin-top: 5px;
  fill: ${(props) => props.disabled ?
    color(props.theme['color.text.body']).setAlpha(0.3).toString() :
    props.theme['color.text.body']}`;

export const AddModalWrapper = styled.div`
  padding: 0px 30px 0;
  height: auto;
`;

export const ContentInfo = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 20px 30px;
  font-size: 16px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px 20px;
  }
`;

export const RequiredAttribute = styled.div`
  color: ${(props) => props.theme['color.red.text']};
  position: relative;
  display: flex;
  justify-content: start;
  width: 100px;
  align-items: center;
`;

export const CircularProgress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const Section = styled.div`
  display: inline-block;
  margin: 10px 0 10px 0;
`;

export const Icon = styled(SVGIcon)`
  cursor: pointer;
  width:30px;
`;

export const StatusIcon = styled.p`
  ${({ exportStatus }) => exportStatus === status.INPROGRESS && css`
  color: ${(theme) => theme['color.greenLight']};
    opacity:  1;
  `}

  ${({ exportStatus }) => exportStatus === status.FAILED && css`
  color: ${({ theme }) => theme.themeId === 'dark' ? theme['color.redLight'] : theme['color.redDark']};
  margin: 5px;
  `}

  ${({ exportStatus }) => exportStatus === status.COMPLETED && css`
  color: ${({ theme }) => theme['color.greenLight']};
  opacity: 0.5;
  `}
  width: 30px;
`;

export const StatusMessage = styled.span`
`;

export const StatusInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 40px;
  padding-top: 10px;
  margin: 0 auto;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? (props.publicationStatus === props.theme['color.redLight'])
      : (props.publicationStatus === props.theme['color.redDark'])};
`;

export const OutputTypeItem = styled.div`
  margin: 0px 0px 18px 8px;
`;

export const ModalTitle = styled.div`
  margin: 20px 0px 20px 0px;
  font-size: 20px;
`;

export const PublicationAlertModalContent = styled(ModalContent)`
  text-align: center;
  padding: 60px 65px 30px 65px;
`;

export const UnauthorizedModalContent = styled(ModalContent)`
  text-align: center;
  padding: 60px 65px 30px 65px;
`;

export const DeleteModalContent = styled(ModalContent)`
  text-align: left;
  margin-bottom: 50px;
`;

export const PublicationAlertModalActions = styled(ModalActions)`
  justify-content: center;
`;

export const UnauthorizedModalActions = styled(ModalActions)`
  justify-content: center;
`;

export const DisabledText = styled.div`
  height: 40px;
  width: 340px;
  margin-top:10px;
`;

export const InputBox = styled.div`
    height: 40px;
    width: 340px;
    position: relative;
    background-color:${(props) => props.theme['color.greyLighter']};
    border-radius: 4px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid ${(props) => props.theme['color.greyDark']};;
    & svg {
      position: absolute;
      top: 8px;
      right: 12.5px;
      left: auto;
      cursor: pointer;
    }
    & span {
      padding: 10px;
      display: flex;
      color: ${(props) => color(props.theme['color.overlay.background']).setAlpha(0.4).toString()};
    }
`;
export const DisabledLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => color(props.theme['color.overlay.background']).setAlpha(0.7).toString()};
`;

export const DoneButton = styled.div`
  display: flex;
  justify-content: end;
`;

export const PublicationModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.format === publishFormat.CHANNEL_PARTNER ? 'space-between' : 'flex-end'};
`;

export const PublicationModalTooltip = styled(Tooltip)`
  width: 240px;
  white-space: pre-line;
  line-height: 1.3;
  text-align: start;
  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    top: 210px;
}`;

export const TocItem = styled.div`
  margin: 0px 0px 18px 8px;
  :last-of-type{
    margin-bottom: 8px;
  }
`;

export const TocLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const TocFeedback = styled.p`
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  color: ${(props) => props.theme['color.red.text']};
  margin: 0;

  & > svg {
    width: 20px;
    height: 1.5em;
    margin-right: 6px;
    overflow: initial;
  }
`;
